import { Inject, Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, switchMap, take } from 'rxjs';

import { Store } from '@ngxs/store';
import { UserState } from '@gea/digital-ui-lib';
import { ENVIRONMENT_CONFIG, EnvironmentConfiguration } from 'src/environments/models/environment.model';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private store: Store, @Inject(ENVIRONMENT_CONFIG) public environment: EnvironmentConfiguration) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const url = request.url;

    if (url.search('i18n') >= 0 || url.search('azure-api.net') >= 0 ||
        url.search('data:image') >= 0 || (url.search(this.environment.appContentStorageURL!)>=0) ) {
        //    console.log(request.headers);
            const newHeaders = request.headers.delete('Authorization');
        //    console.log(newHeaders);
            const modifiedReq = request.clone({ headers: newHeaders });
         //   console.log('Req '+url);
            return next.handle(modifiedReq);
    }


    if(url.search(this.environment.baseURL)>=0)
    {
        return this.store.select(UserState.token)
        .pipe(
          take(1),
          switchMap((token) => {
            let res = request.clone({ setHeaders: { Authorization: `Bearer ${token}` } });
            return next.handle(res);
          })
        );
    }

    return this.store.select(UserState.token)
      .pipe(
        take(1),
        switchMap((token) => {
      //    console.log('Adding auth for '+url);
          let res = request.clone({ setHeaders: { Authorization: `Bearer ${token}` }, withCredentials: true });
          return next.handle(res);
        })
      );
  }
}
